//#region libraries

// react
import React from 'react';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { setLayout, selectLayout } from '_redux/slices/timeline/timeline-control';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// bootstrap
import { Form } from 'react-bootstrap';

//#endregion

const LayoutSwitch = () => {

    //#region redux
    const dispatch = useDispatch();
    const selectedLayout = useSelector(selectLayout);
    const usedTheme = useSelector(selectUsedTheme);
    //#endregion

    //#region functions
    const handleSwitch = () => {
        if(selectedLayout == 'default'){
            dispatch(setLayout('jer'));
        }
        else {
            dispatch(setLayout('default'));
        }
    };
    //#endregion

    return (
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                
                <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                    Layout
                </span>

                {/* Toggle for modes */}
                <Form.Check
                    onChange={handleSwitch}
                    type="switch"
                    checked={selectedLayout === 'jer'}
                    value={selectedLayout == 'jer'}
                    style={{ marginLeft: '16px' }}
                />
            </div>

            <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                Switch to an layout where the flight list is displayed beside the timeline, instead of below it.
            </span>
        </div>
    );
};

export default LayoutSwitch;
